/**
 * Color swatch clicks + hover tooltips — collection grid, homepage best sellers, PDP Recommended.
 */
(function () {
  var TIP_DURATION_MS = 1000;

  var LIFESTYLE_PRODUCT_DEFAULTS = {
    'artsy-eyeglasses': { position: '50% 33%', zoomOrigin: '50% 30%', alignY: '0' },
    'fanciful-eyeglasses': { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' },
    'sherman-eyeglasses': { position: '50% 43%', zoomOrigin: '50% 40%', alignY: '0' }
  };

  var LIFESTYLE_OVERRIDES = {
    'tiffany-eyeglasses': {
      Brown: { position: '50% 44%', zoomOrigin: '50% 40%', alignY: '-8%' }
    },
    'etiquette-eyeglasses': {
      Gold: { position: '50% 52%', zoomOrigin: '50% 46%', alignY: '0' },
      Gunmetal: { position: '50% 52%', zoomOrigin: '50% 46%', alignY: '0' },
      Black: { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' }
    },
    'elwood-eyeglasses': {
      'Black Matte': { position: '50% 36%', zoomOrigin: '50% 33%', alignY: '0' },
      Crystal: { position: '50% 36%', zoomOrigin: '50% 33%', alignY: '0' },
      'Brown Matte': { position: '50% 33%', zoomOrigin: '50% 30%', alignY: '0' },
      'Grey Matte': { position: '50% 43%', zoomOrigin: '50% 40%', alignY: '0' }
    },
    'classic-eyeglasses': {
      'Black Matte/Gunmetal': { position: '50% 36%', zoomOrigin: '50% 33%', alignY: '0' },
      'Navy Matte/Gunmetal': { position: '50% 36%', zoomOrigin: '50% 33%', alignY: '0' },
      'Brown Matte/Gold': { position: '50% 33%', zoomOrigin: '50% 30%', alignY: '0' }
    },
    'slick-eyeglasses': {
      Tortoise: { position: '50% 40%', zoomOrigin: '50% 37%', alignY: '0' },
      Grey: { position: '50% 36%', zoomOrigin: '50% 33%', alignY: '0' },
      Crystal: { position: '50% 36%', zoomOrigin: '50% 33%', alignY: '0' },
      Navy: { position: '50% 50%', zoomOrigin: '50% 46%', alignY: '0' },
      White: { position: '50% 50%', zoomOrigin: '50% 46%', alignY: '0' }
    },
    'accord-eyeglasses': {
      Tortoise: { position: '50% 50%', zoomOrigin: '50% 46%', alignY: '0' },
      Black: { position: '50% 50%', zoomOrigin: '50% 46%', alignY: '0' }
    },
    'adapt-eyeglasses': {
      'Lilac Crystal': { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' },
      'Rose Crystal': { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' },
      Crystal: { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' }
    },
    'addison-eyeglasses': {
      Purple: { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' },
      Burgundy: { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' },
      Black: { position: '50% 33%', zoomOrigin: '50% 30%', alignY: '0' }
    },
    'advice-eyeglasses': {
      'Black/Olive': { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' },
      'Black/Purple': { position: '50% 33%', zoomOrigin: '50% 30%', alignY: '0' }
    },
    'davina-eyeglasses': {
      'Sienna/Crystal': { position: '50% 33%', zoomOrigin: '50% 30%', alignY: '0' },
      'Teal/Crystal': { position: '50% 33%', zoomOrigin: '50% 30%', alignY: '0' },
      'Black/Crystal': { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' }
    },
    'conserve-eyeglasses': {
      'Grey Crystal': { position: '50% 33%', zoomOrigin: '50% 30%', alignY: '0' }
    },
    'advocate-eyeglasses': {
      'Crystal Frost/Black Matte': { position: '50% 33%', zoomOrigin: '50% 30%', alignY: '0' },
      'Grey Matte/Charcoal': { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' },
      'Navy Matte': { position: '50% 33%', zoomOrigin: '50% 30%', alignY: '0' }
    },
    'annette-eyeglasses': {
      'Blue Crystal/Tortoise': { position: '50% 43%', zoomOrigin: '50% 40%', alignY: '0' },
      'Black/Purple': { position: '50% 43%', zoomOrigin: '50% 40%', alignY: '0' }
    },
    'attention-eyeglasses': {
      'Navy/Gold': { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' }
    },
    'balmy-eyeglasses': {
      'Black/Crystal': { position: '50% 43%', zoomOrigin: '50% 40%', alignY: '0' },
      Purple: { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' },
      'Burgundy/Burgundy Crystal': { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' }
    },
    'confide-eyeglasses': {
      'Crystal/Black': { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' },
      'Crystal/Blue': { position: '50% 43%', zoomOrigin: '50% 40%', alignY: '0' },
      'Crystal/Red': { position: '50% 43%', zoomOrigin: '50% 40%', alignY: '0' }
    },
    'congress-eyeglasses': {
      'Gunmetal/Brown': { position: '50% 43%', zoomOrigin: '50% 40%', alignY: '0' },
      'Silver/Black': { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' },
      'Blue/Black': { position: '50% 43%', zoomOrigin: '50% 40%', alignY: '0' }
    },
    'dee-eyeglasses': {
      'Plum/Crystal': { position: '50% 43%', zoomOrigin: '50% 40%', alignY: '0' },
      'Brown/Crystal': { position: '50% 43%', zoomOrigin: '50% 40%', alignY: '0' }
    },
    'fabiana-eyeglasses': {
      'Mint Cry/Tortoise': { position: '50% 43%', zoomOrigin: '50% 40%', alignY: '0' }
    },
    'gravity-eyeglasses': {
      'Matte Black/Tortoise': { position: '50% 38%', zoomOrigin: '50% 35%', alignY: '0' },
      'Matte Gunmetal/Black': { position: '50% 48%', zoomOrigin: '50% 45%', alignY: '0' },
      'Matte Brown/Tortoise': { position: '50% 48%', zoomOrigin: '50% 45%', alignY: '0' }
    },
    'natasha-eyeglasses': {
      'Purple/Gold': { position: '50% 48%', zoomOrigin: '50% 45%', alignY: '0' },
      'Brown/Gold': { position: '50% 48%', zoomOrigin: '50% 45%', alignY: '0' }
    }
  };

  function isSwatchContext(el) {
    return el && el.closest('.hp-best-sellers__card, .ciw-card');
  }

  function swatchColorName(swatch) {
    var label = swatch.getAttribute('aria-label') || '';
    var match = label.match(/^View\s+(.+?)(?:\s-\s|$)/i);
    if (!match) return '';
    return match[1].replace(/\s-\sSold Out$/i, '').trim();
  }

  function productHandleFromCard(card) {
    if (card.getAttribute('data-handle')) {
      return card.getAttribute('data-handle');
    }
    var link = card.querySelector('.hp-best-sellers__product-link, .ciw-card__info, .ciw-card__image');
    var href = link && link.getAttribute('href');
    if (!href) return '';
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function lifestyleSettingsForSwatch(card, swatch) {
    var handle = productHandleFromCard(card);
    var color = swatchColorName(swatch);
    var override = LIFESTYLE_OVERRIDES[handle] && LIFESTYLE_OVERRIDES[handle][color];
    if (override) return override;

    var productDefault = LIFESTYLE_PRODUCT_DEFAULTS[handle];
    if (productDefault) return productDefault;

    var position = swatch.getAttribute('data-lifestyle-position');
    if (position) {
      var zoom = swatch.getAttribute('data-lifestyle-zoom-scale') || '';
      if (handle === 'etiquette-eyeglasses' && (color === 'Gold' || color === 'Gunmetal') && zoom === '1') {
        zoom = '';
      }
      if (handle === 'tiffany-eyeglasses' && color === 'Brown' && zoom === '1') {
        zoom = '';
      }
      return {
        position: position,
        zoomOrigin: swatch.getAttribute('data-lifestyle-zoom-origin') || position,
        zoom: zoom,
        alignY: swatch.getAttribute('data-lifestyle-align-y') || '0'
      };
    }

    return {
      position: '50% 28%',
      zoomOrigin: '50% 28%',
      zoom: '',
      alignY: '0'
    };
  }

  var SWATCH_TIP_PORTAL_MS = 2500;

  function isMobileSwatchPortalViewport() {
    return window.innerWidth <= 749;
  }

  function isMobileSwatchPortalItem(item) {
    return !!(item && isSwatchContext(item) && isMobileSwatchPortalViewport());
  }

  function isHpBestSellersDesktopPortalItem(item) {
    return !!(item && item.closest('.hp-best-sellers__card') && window.innerWidth >= 750);
  }

  function getSwatchLabel(swatch) {
    var label = swatch.getAttribute('aria-label') || '';
    var match = label.match(/^View\s+(.+?)(?:\s-\s|$)/i);
    return match ? match[1].replace(/\s-\sSold Out$/i, '').trim() : '';
  }

  function ensureSwatchTipPortal() {
    var portal = document.getElementById('ciw-swatch-tip-portal');
    if (!portal) {
      portal = document.createElement('div');
      portal.id = 'ciw-swatch-tip-portal';
      portal.setAttribute('role', 'status');
      portal.setAttribute('aria-live', 'polite');
      document.body.appendChild(portal);
    }
    return portal;
  }

  function hideSwatchTipPortal() {
    var portal = document.getElementById('ciw-swatch-tip-portal');
    if (!portal) return;
    if (portal._hideTimer) {
      window.clearTimeout(portal._hideTimer);
      portal._hideTimer = null;
    }
    portal.classList.remove('is-visible');
    portal.textContent = '';
    portal.style.left = '';
    portal.style.top = '';
    portal.style.position = '';
  }

  function showHpBestSellersDesktopTipPortal(swatch) {
    var text = getSwatchLabel(swatch);
    if (!text) return;

    var portal = ensureSwatchTipPortal();
    if (portal._hideTimer) {
      window.clearTimeout(portal._hideTimer);
      portal._hideTimer = null;
    }

    portal.textContent = text;
    portal.classList.remove('is-visible');
    portal.classList.add('is-hp-desktop-above');
    portal.style.position = 'fixed';
    portal.style.left = '-9999px';
    portal.style.top = '0';
    portal.classList.add('is-visible');

    var width = portal.offsetWidth;
    var height = portal.offsetHeight;
    var rect = swatch.getBoundingClientRect();
    var margin = 12;
    var gap = 11;
    var left = rect.left + rect.width / 2 - width / 2;
    left = Math.max(margin, Math.min(left, window.innerWidth - width - margin));
    var top = Math.max(margin, rect.top - height - gap);

    portal.style.left = left + 'px';
    portal.style.top = top + 'px';
  }

  function showSwatchTipPortal(swatch) {
    if (!isMobileSwatchPortalViewport()) return;
    var text = getSwatchLabel(swatch);
    if (!text) return;

    var portal = ensureSwatchTipPortal();
    if (portal._hideTimer) {
      window.clearTimeout(portal._hideTimer);
      portal._hideTimer = null;
    }

    portal.classList.remove('is-hp-desktop-above');
    portal.textContent = text;
    portal.classList.remove('is-visible');
    portal.style.left = '-9999px';
    portal.style.top = '0';
    portal.classList.add('is-visible');

    var width = portal.offsetWidth;
    var rect = swatch.getBoundingClientRect();
    var margin = 12;
    var gap = 6;
    var left = rect.left + rect.width / 2 - width / 2;
    left = Math.max(margin, Math.min(left, window.innerWidth - width - margin));
    var top = rect.bottom + gap;

    portal.style.left = left + 'px';
    portal.style.top = top + 'px';

    portal._hideTimer = window.setTimeout(hideSwatchTipPortal, SWATCH_TIP_PORTAL_MS);
  }

  function clearTipTimer(item) {
    if (item._ciwTipTimer) {
      window.clearTimeout(item._ciwTipTimer);
      item._ciwTipTimer = null;
    }
  }

  function hideTip(item) {
    clearTipTimer(item);
    item.classList.remove('is-tip-visible');
    if (item && isHpBestSellersDesktopPortalItem(item)) {
      hideSwatchTipPortal();
    }
  }

  function showTip(item) {
    if (isMobileSwatchPortalItem(item)) return;

    var container = item.closest('.hp-best-sellers__card, .ciw-card');
    if (container) {
      container.querySelectorAll('.ciw-card__swatch-item.is-tip-visible').forEach(function (other) {
        if (other !== item) hideTip(other);
      });
    }

    clearTipTimer(item);

    if (isHpBestSellersDesktopPortalItem(item)) {
      hideSwatchTipPortal();
      var hpSwatch = item.querySelector('.ciw-card__swatch');
      if (hpSwatch) showHpBestSellersDesktopTipPortal(hpSwatch);
      item._ciwTipTimer = window.setTimeout(hideSwatchTipPortal, TIP_DURATION_MS);
      return;
    }

    item.classList.add('is-tip-visible');

    item._ciwTipTimer = window.setTimeout(function () {
      hideTip(item);
    }, TIP_DURATION_MS);
  }

  function applyLifestylePosition(card, swatch) {
    if (
      !card.classList.contains('ciw-card--lifestyle-fill') &&
      !card.classList.contains('hp-best-sellers__card--lifestyle-fill')
    ) {
      return;
    }

    var settings = lifestyleSettingsForSwatch(card, swatch);
    card.style.setProperty('--ciw-lifestyle-pos', settings.position);
    card.style.setProperty('--ciw-lifestyle-zoom-origin', settings.zoomOrigin);
    card.style.setProperty('--ciw-lifestyle-align-y', settings.alignY);
    if (settings.zoom) {
      card.style.setProperty('--ciw-lifestyle-zoom', settings.zoom);
    } else {
      card.style.removeProperty('--ciw-lifestyle-zoom');
    }

    var hpSecondaryImg = card.querySelector('.hp-best-sellers__img--secondary');
    if (hpSecondaryImg) {
      hpSecondaryImg.style.setProperty('object-position', settings.position, 'important');
    }
    var gridHoverImg = card.querySelector('.ciw-card__img--hover');
    if (gridHoverImg) {
      gridHoverImg.style.setProperty('object-position', settings.position, 'important');
    }
  }

  function initLifestyleCards(root) {
    (root || document).querySelectorAll('.hp-best-sellers__card--lifestyle-fill, .ciw-card--lifestyle-fill').forEach(function (card) {
      var activeSwatch = card.querySelector('.ciw-card__swatch--active');
      if (activeSwatch) {
        applyLifestylePosition(card, activeSwatch);
      }
    });
  }

  function applyHpBestSellerSwatch(swatch) {
    var card = swatch.closest('.hp-best-sellers__card');
    if (!card) return;

    var primaryImg = card.querySelector('.hp-best-sellers__img--primary');
    var frontUrl = swatch.getAttribute('data-image-front');
    if (!frontUrl || !primaryImg) return;

    primaryImg.src = frontUrl;
    primaryImg.removeAttribute('srcset');

    var mediaLink = card.querySelector('.hp-best-sellers__media-link');
    var secondaryImg = card.querySelector('.hp-best-sellers__img--secondary');
    var hoverUrl = swatch.getAttribute('data-image-hover');

    if (hoverUrl && mediaLink) {
      if (!secondaryImg) {
        secondaryImg = document.createElement('img');
        secondaryImg.className = 'hp-best-sellers__img hp-best-sellers__img--secondary';
        secondaryImg.loading = 'lazy';
        secondaryImg.alt = (primaryImg.alt || '') + ' alternate view';
        mediaLink.appendChild(secondaryImg);
      }
      secondaryImg.src = hoverUrl;
      secondaryImg.removeAttribute('srcset');
      card.classList.add('hp-best-sellers__card--has-hover-image');
    } else {
      if (secondaryImg) secondaryImg.remove();
      card.classList.remove('hp-best-sellers__card--has-hover-image');
    }

    applyLifestylePosition(card, swatch);
    setActiveSwatch(card, swatch);
  }

  function applyCiwGridSwatch(swatch) {
    var card = swatch.closest('.ciw-card');
    if (!card) return;

    var imageLink = card.querySelector('.ciw-card__image');
    if (!imageLink) return;

    var frontImg = imageLink.querySelector('.ciw-card__img--default');
    var frontUrl = swatch.getAttribute('data-image-front');
    if (!frontUrl || !frontImg) return;

    frontImg.src = frontUrl;
    frontImg.removeAttribute('srcset');

    var hoverUrl = swatch.getAttribute('data-image-hover');
    var hoverImg = imageLink.querySelector('.ciw-card__img--hover');

    if (hoverUrl) {
      if (!hoverImg) {
        hoverImg = document.createElement('img');
        hoverImg.className = 'ciw-card__img ciw-card__img--hover';
        hoverImg.width = 400;
        hoverImg.height = 300;
        hoverImg.loading = 'lazy';
        hoverImg.alt = frontImg.alt || '';
        imageLink.appendChild(hoverImg);
      }
      hoverImg.src = hoverUrl;
      hoverImg.removeAttribute('srcset');
      card.classList.add('ciw-card--has-hover');
    } else {
      if (hoverImg) hoverImg.remove();
      card.classList.remove('ciw-card--has-hover');
    }

    applyLifestylePosition(card, swatch);
    setActiveSwatch(card, swatch);
  }

  function setLinkVariant(link, variantId) {
    if (!link || !variantId) return;
    var href = link.getAttribute('href');
    if (!href || href.indexOf('/products/') === -1) return;

    var parts = href.split('?');
    var base = parts[0];
    var params = new URLSearchParams(parts[1] || '');
    params.set('variant', String(variantId));
    var qs = params.toString();
    link.setAttribute('href', base + (qs ? '?' + qs : ''));
  }

  function updateCardProductLinks(card, swatch) {
    var variantId = swatch.getAttribute('data-variant-id');
    if (!variantId) return;

    card.querySelectorAll(
      '.ciw-card__image, .ciw-card__info, .hp-best-sellers__media-link, .hp-best-sellers__product-link'
    ).forEach(function (link) {
      setLinkVariant(link, variantId);
    });
  }

  function setActiveSwatch(card, swatch) {
    card.querySelectorAll('.ciw-card__swatch').forEach(function (btn) {
      btn.classList.remove('ciw-card__swatch--active');
      btn.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('ciw-card__swatch--active');
    swatch.setAttribute('aria-pressed', 'true');
    updateCardProductLinks(card, swatch);
  }

  function applyAlternatingHouseSwatches(root) {
    var grid =
      (root && root.querySelector && root.querySelector('#product-grid, .ciw-product-grid')) ||
      document.getElementById('product-grid') ||
      document.querySelector('.ciw-product-grid');
    if (!grid || grid.dataset.ciwEyeglassesShopAllSort !== 'true') return;

    var houseCards = grid.querySelectorAll('.ciw-card--house');
    if (!houseCards.length) return;

    houseCards.forEach(function (card, houseIdx) {
      var swatches = card.querySelectorAll(
        '.ciw-card__swatch:not(.ciw-card__swatch--unavailable)'
      );
      if (swatches.length <= 1) return;

      var pick = swatches[houseIdx % swatches.length];
      applyCiwGridSwatch(pick);
    });
  }

  if (window.ciwCardSwatchClickInit) return;
  window.ciwCardSwatchClickInit = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initLifestyleCards();
    });
  } else {
    initLifestyleCards();
  }

  document.addEventListener('ciw:shop-all-sort-complete', function () {
    applyAlternatingHouseSwatches();
  });

  document.addEventListener(
    'scroll',
    function (e) {
      if (!e.target.closest || !e.target.closest('.hp-best-sellers__track')) return;
      hideSwatchTipPortal();
    },
    true
  );

  document.addEventListener('mouseover', function (e) {
    var item = e.target.closest('.ciw-card__swatch-item');
    if (!item || !isSwatchContext(item)) return;
    if (isMobileSwatchPortalItem(item)) return;
    if (item.contains(e.relatedTarget)) return;
    showTip(item);
  });

  document.addEventListener('mouseout', function (e) {
    var item = e.target.closest('.ciw-card__swatch-item');
    if (!item || !isSwatchContext(item)) return;
    if (isMobileSwatchPortalItem(item)) return;
    if (item.contains(e.relatedTarget)) return;
    hideTip(item);
  });

  document.addEventListener('focusin', function (e) {
    if (!e.target.closest('.ciw-card__swatch')) return;
    var item = e.target.closest('.ciw-card__swatch-item');
    if (!item || !isSwatchContext(item)) return;
    if (isMobileSwatchPortalItem(item)) return;
    showTip(item);
  });

  document.addEventListener('focusout', function (e) {
    var item = e.target.closest('.ciw-card__swatch-item');
    if (!item || !isSwatchContext(item)) return;
    if (isMobileSwatchPortalItem(item)) return;
    if (item.contains(e.relatedTarget)) return;
    hideTip(item);
  });

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.ciw-card__swatch');
    if (!swatch) return;

    var hpCard = swatch.closest('.hp-best-sellers__card');
    var grid = swatch.closest(
      '#product-grid, .ciw-product-grid, .ciw-pdp-product-rec, .ciw-recently-viewed, .ciw-trending__track, .ciw-search-page__grid, .hp-best-sellers__track'
    );

    if (!hpCard && !grid) return;

    e.preventDefault();
    e.stopPropagation();

    if (hpCard) {
      applyHpBestSellerSwatch(swatch);
    } else {
      applyCiwGridSwatch(swatch);
    }

    if (isMobileSwatchPortalViewport()) {
      window.requestAnimationFrame(function () {
        showSwatchTipPortal(swatch);
      });
    }
  });
})();
